import { createContext, useState } from 'react';

const DataGridContext = createContext({
  filteredUsers: [],
  setFilteredUsers: (setFilteredUsers) => {},
});

export function DataGridContextProvider(props) {

  const [filteredDataGridUsers, setFilteredDataGridUsers] = useState(null);
  const [tab, setTab] = useState("Users");
  const [filterStatelocal, setFilterStateLocal] = useState(null)

  const areSameFilteredUsers = (prev, next) => {
    if (prev === next) return true;
    if (!Array.isArray(prev) || !Array.isArray(next)) return false;
    if (prev.length !== next.length) return false;
    return prev.every((id, index) => id === next[index]);
  };

  function updateFilteredDataGridUsers(userIDs) {
    setFilteredDataGridUsers((prev) =>
      areSameFilteredUsers(prev, userIDs) ? prev : userIDs
    );
  }

  function updateTabName(tabName) {
    setTab(tabName);
  }

  const context = {
    filteredDataGridUsers: filteredDataGridUsers,
    updateFilteredDataGridUsers: updateFilteredDataGridUsers,
    tab: tab,
    updateTabName: updateTabName,
    setFilterStateLocal,
    filterStatelocal
  };

  return <DataGridContext.Provider value={context}>
    {props.children}
  </DataGridContext.Provider>
}

export default DataGridContext;
